import './styles.scss';

import { ListGroup, ListGroupProps } from 'react-bootstrap';

import { CategoriesListItem } from '@/features/Settings/pages/Categories/components/CategoriesList/CategoriesListItem';
import { CategoryGroupLink } from '@/features/Settings/api/services/training/searchQuestionnaireCategoryGroups';
import { QuestionnaireCategory } from '@/models/gen/graphql';
import { getClasses } from '@/utils';

type CategoriesListProps = ListGroupProps & {
  categories: QuestionnaireCategory[];
  questionCounts: Record<string, number>;
  categoryGroups?: Record<string, CategoryGroupLink[]>;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
};

export const CategoriesList = ({
  categories,
  questionCounts,
  categoryGroups,
  onEdit,
  onDelete,
  className,
  ...props
}: CategoriesListProps) => {
  return (
    <ListGroup {...props} className={getClasses('CategoriesList', className)}>
      {!categories.length && (
        <div className="CategoriesList-Empty text-center">
          <i className="fa fa-inbox" /> <span>No Data</span>
        </div>
      )}
      {categories.map((category) => (
        <CategoriesListItem
          key={category.id}
          name={category.name}
          description={category.description}
          previewStyle={{ backgroundColor: category.color }}
          id={category.id}
          questionCount={questionCounts[category.id] || 0}
          groupNames={(categoryGroups?.[category.id] || []).map(({ groupName }) => groupName)}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </ListGroup>
  );
};
